export default "__VITE_ASSET__CCRGJw_P__"